import { render, staticRenderFns } from "./DetailHeaderNav.vue?vue&type=template&id=13c73a55&"
import script from "./DetailHeaderNav.vue?vue&type=script&lang=js&"
export * from "./DetailHeaderNav.vue?vue&type=script&lang=js&"
import style0 from "./DetailHeaderNav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports